

import { UIElement } from "./NServer";

export const showTab = () => {
    const tabBar = document.getElementById('appTabBar');
    if (tabBar !== null) {
        tabBar.style.display = 'flex';
    }
};

export const hideTab = () => {
   const tabBar = document.getElementById('appTabBar');
   if (tabBar !== null) {
      tabBar.style.display = 'none';
   }
}; 

export const updateTab = () => {
    /* DEL
    // shorts menu
    const showWallet = UIElement("nc_media");
    const walletTab : HTMLElement = document.getElementsByClassName("nc_media").item(0) as HTMLElement;
    if (walletTab !== null) 
    {
        if (showWallet == "")
            walletTab.style.display = 'flex';
        else
            walletTab.style.display = 'none';
    }

    // add menu
    const showChat = UIElement("nc_add");
    const chatTab : HTMLElement = document.getElementsByClassName("nc_add").item(0) as HTMLElement;
    if (chatTab !== null) 
    {
        if (showChat == "")
            chatTab.style.display = 'flex';
        else
            chatTab.style.display = 'none';
    }

    // vote menu
    const showShop = UIElement("nc_vote");
    const shopTab : HTMLElement = document.getElementsByClassName("nc_vote").item(0) as HTMLElement;
    if (shopTab !== null) 
    {
        if (showShop == "")
            shopTab.style.display = 'flex';
        else
            shopTab.style.display = 'none';
    }

    // studio menu
    const showStudio = UIElement("nc_studio");
    const studioTab : HTMLElement = document.getElementsByClassName("nc_studio").item(0) as HTMLElement;
    if (studioTab !== null) 
    {
        if (showStudio == "")
            studioTab.style.display = 'flex';
        else
            studioTab.style.display = 'none';
    }
    */
}; 